import { searchInCollection } from "../typesenseFetchClient.js";

export default async function fetchProductSummary(productId) {
  try {
    const searchParameters = {
      max_facet_values: 1000,
      q: "*",
      // query_by: 'productName',
      filter_by: `productId:=${productId}`,
    };

    const data = await searchInCollection("stamped_review_summaries", searchParameters);

    const documents = data.hits.map(hit => hit.document);
    return documents.length ? documents[0] : null;
  } catch (error) {
    console.error("Error of fetchProductSummary:", error);
    return null;
  }
}
